import './App.css';
import './styles/responsive.css';
import React from 'react';
import { BrowserRouter, HashRouter, Routes, Route } from 'react-router-dom';

import Navbar from 'compoments/layout/navbar/Navbar';
import Footer from 'compoments/layout/footer/Footer';
import ScrollTopButton from 'compoments/layout/scrollButton/ScrollButton';
import AppRoutes from 'routes/AppRoutes';
import FeedbackForm from 'pages/Home/components/FeedbackForm'; 

function App() {
  const isHashRoute = window.location.hash.startsWith('#/3-day-natural-healt-retreat');

  if (isHashRoute) {
    // Render only FeedbackForm when hash route matches
    return (
      <HashRouter>
        <Routes>
          <Route path="/3-day-natural-healt-retreat" element={<FeedbackForm />} />
        </Routes>
      </HashRouter>
    );
  }

  // Default app structure using BrowserRouter
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <AppRoutes />
        <Footer />
        <ScrollTopButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
